import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconArrowLeftFilled = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M16.9084 16.4658V7.35531C16.9084 5.92893 15.2577 5.13672 14.1449 6.02907L8.68283 10.4091C7.85468 11.0732 7.83098 12.3255 8.63341 13.0204L14.0955 17.7508C15.1964 18.7044 16.9084 17.9223 16.9084 16.4658Z" }),
});

export { IconArrowLeftFilled };
